// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1800":"9bc47c7a53fcce2e","2143":"5029f604a18d7e8f"}[chunkId] + ".css";
};